// extracted by mini-css-extract-plugin
export default {"wrapper":"NiXw3q579P4isniVA0U2","inner":"CB6BtLbibYUKzpU4zOKv","intro":"QF9jxFsx3r0lGVVSLgnA","headline":"XNHt9vMzAw06dsB5xiLp","text":"f_XNtwzsW6OJZFhUkHdR"};